import { render } from "./StairstepHistory.vue?vue&type=template&id=44654a16"
import script from "./StairstepHistory.vue?vue&type=script&lang=ts"
export * from "./StairstepHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script